<template>
  <div class="list content">
    <form
      @submit.prevent="doAddRoom()"
    >
      <v-row no-gutters class="my-10" justify="center">
        <v-col cols="8">
          <v-text-field
            :rules="rules"
            counter="15"
            v-model="room_name"
            @keypress.enter.exact.prevent="doAddRoom()"
          ></v-text-field>
        </v-col>
        <v-col class="mt-4 ml-3" cols="2">
          <v-btn
            small
            color="primary"
            type="submit"
          >
            ルーム追加
          </v-btn>
        </v-col>
      </v-row>
    </form>
    ルーム一覧
    <section
      v-for="{ key, name, owner } in displayLists" 
      :key="key"
      class="item mt-5"
      justify="space-between"
    >
      <v-hover v-slot:default="{ hover }">    
        <v-card :elevation="hover ? 8 : 2" class="px-6 py-2 mx-2" :to="'/'+key">      
          <v-row no-gutters @click="doEnterRoom({link:key, name:name})">
            <v-col  cols="11">
      			 {{name}}
            </v-col>
            <v-col cols="1">
              <v-btn text x-small
                v-if="user.uid == owner"
                type="button"
                @click.stop.prevent="doRemoveRoom(key)"
              >
                削除      
              </v-btn>            
            </v-col>
          </v-row>
        </v-card>
      </v-hover>     
  	</section>
    <v-pagination
      class="mt-5 mb-10"
      v-model="page"
      :length="length"
      @input = "pageChange"
    ></v-pagination>
  </div>
</template>

<script>
import firebase from 'firebase'
import Firebase from './../firebase'
import { mapActions } from 'vuex'
export default {
	data() {
		return{
      room_name: '',
      page: 1,
      length:0,
      displayLists: [],
      pageSize: 10,
      rules: [v => v.length <= 15 || '15文字まで入力できます。'],
    	}
  	},
  computed: {
    rooms() {
      return this.$store.getters.getRooms.slice().reverse()
    },
    user() {
      return this.$store.getters.user
    },
  },
  created () {
    const user = this.$store.getters.user
  
    this.roomDb = firebase.database().ref('room')
    if (user) {
      this.$store.dispatch('resetRooms')
      this.roomDb.off()
      this.roomDb.on('child_added', this.roomAdded)
      this.roomDb.on('child_removed', this.roomRemoved)
      this.roomDb.on('child_changed', this.roomChanged)
    } else {
      this.roomDb.off('child_added', this.roomAdded)
      this.roomDb.off('child_removed', this.roomRemoved)
      this.roomDb.off('child_changed', this.roomChanged)
    }
  }, 
  methods: {
    pageChange (pageNumber) {
      this.displayLists = this.rooms.slice(this.pageSize*(pageNumber -1), this.pageSize*(pageNumber))
    },
    pageSet () {
      const rooms = this.$store.getters.getRooms.slice().reverse() 
      this.length = Math.ceil(rooms.length/this.pageSize)
      this.displayLists = rooms.slice(this.pageSize*(this.page -1), this.pageSize*(this.page))
    },
    doAddRoom () {
      const user = this.$store.getters.user
      if(this.room_name.length <= 15){
        if (user.uid && this.room_name.length) {
          firebase.database().ref('room').push({
            name: this.room_name,
            owner: user.uid,
            timestamp: firebase.database.ServerValue.TIMESTAMP
          }, () => {
            this.room_name = '' // フォームを空にする
          })
        }
      }
    },
    ...mapActions([
      'roomAdded',
      'roomRemoved',
    	'doEnterRoom',
    ]),
    doRemoveRoom (key) {
      const user = this.$store.getters.user
      if (user.uid) {
        this.roomDb.child(key).remove()
      }
    },
    roomAdded (snap) {
      this.$store.dispatch('roomAdded', snap)
      this.pageSet()
    },
    roomRemoved (snap) {
      this.$store.dispatch('roomRemoved', snap)

   	  firebase.database().ref('message').child(snap.key).remove()
      this.pageSet()
    },
    roomChanged (snap) {
      const index = this.$store.getters.getRooms.findIndex((v) => v.key === snap.key)
      const index_in = this.$store.getters.getRoomsIn.findIndex((v) => v.link === snap.key)
      const changed_room = {
        name: snap.val().name,
        index: index,
        index_in: index_in,
      }
      this.$store.dispatch('changeRoom', changed_room)
      this.pageSet()
    },
  },
}
</script>

<style scoped>

.content {
  margin: 0 auto;
  padding: 0 10px;
  max-width: 600px;
}

</style>